import { AsyncPipe, NgIf } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { LocalStorageManager } from '@cutting/main/shared/helper/local-storage-manager.helper';
import { fuseAnimations } from '@fuse/animations';
import { CuttingClientIdentification, CuttingClientOptions, ICustomResponse } from 'cloud-shared-lib';
import { Observable } from 'rxjs';
import { skip, tap } from 'rxjs/operators';

import { MatLegacySnackBarModule, MatLegacySnackBar as MatSnackBar } from '@angular/material/legacy-snack-bar';
import { OrderDetailService } from '../order-detail.service';
import { CustomDocumentsComponent } from './custom-documents/custom-documents.component';
import { StaticDocumentsComponent } from './static-documents/static-documents.component';
import { SysDocumentsComponent } from './sys-documents/sys-documents.component';

@Component({
  selector: 'cutting-order-documents',
  templateUrl: './order-documents.component.html',
  styleUrls: ['./order-documents.component.scss'],
  standalone: true,
  imports: [
    AsyncPipe,
    NgIf,
    StaticDocumentsComponent,
    SysDocumentsComponent,
    CustomDocumentsComponent,
    MatLegacySnackBarModule,
  ],
  animations: fuseAnimations,
})
export class OrderDocumentsComponent implements OnInit {
  @Input() editableOrder = false;

  clientOptions: CuttingClientOptions = undefined;
  userInfo$: Observable<ICustomResponse<{ publicApiKey: string }>>;

  publicApiKey = '';

  get client(): CuttingClientIdentification {
    return LocalStorageManager.client;
  }

  constructor(private orderDetailService: OrderDetailService, private snackBar: MatSnackBar) {}

  ngOnInit(): void {
    this.userInfo$ = this.orderDetailService.getUserInfo().pipe(
      skip(1),
      tap(res => {
        if (res.error || !res.result?.publicApiKey) {
          this.snackBar.open(
            $localize`Для корректного формирования документов необходимо сгенерировать Публичный ключ API`,
            'OK',
            { duration: 10000 }
          );
        } else {
          this.publicApiKey = res.result?.publicApiKey || '';
        }
      })
    );
  }
}
